var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"iframe-block",style:({ padding: _vm.blockPadding })},[(_vm.isBuilderContext())?[_c('div',{staticClass:"iframe-block__screenshot-overlay"},[_c('v-icon',{staticClass:"mb-1",attrs:{"size":"2.5rem","icon":"open_in_browser"}}),_vm._v(" "+_vm._s(_vm.getHostName(_vm.url))+" Embed ")],1)]:_vm._e(),_c('iframe',{key:_vm.url,class:[
      'iframe-block__iframe w-100',
      { '--readonly': _vm.isBuilderContext() }
    ],style:({
      width: '100%',
      height: _vm.height,
      minHeight: _vm.height,
      minHeight: ("calc(" + _vm.height + " + env(safe-area-inset-top))")
    }),attrs:{"width":"100%","src":_vm.url,"allowfullscreen":"","allowtransparency":"","allow":"autoplay; fullscreen;clipboard-write; encrypted-media; picture-in-picture; web-share;"}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }